/* eslint-disable jsx-a11y/label-has-associated-control */
import React, { useEffect, useState } from 'react';
import { Grid, Button, Select, MenuItem } from '@material-ui/core';
import { makeStyles } from '@material-ui/styles';
import Modal from 'react-modal';
import CloseIcon from '@material-ui/icons/Close';
import { useDispatch, useSelector } from 'react-redux';
import ChangeJourneyCard from './ChangeJourneyCard';
import Theme from '../ui/Theme';
import { getLevelDetails, showProgress } from '../../redux/actions/DealershipActions';
import service from '../../apis/service';
import { apiEndpoints } from '../../constants/apiEndpoints';

const useStyles = makeStyles(() => ({
  frameStyle: {
    width: '343px',
    height: '45px',

    marginTop: '20px',
  },
  contentStyle: {
    width: '343px',
    height: '439px',

    marginTop: '20px',
  },
  titleFrame: {
    width: '283px',
    height: '45px',
  },
  searchFrame: {
    width: '283px',
    height: '45px',
    background: Theme.palette.secondary.main,
    marginLeft: '2%',
  },
  closeIcon: {
    width: '15px',
    height: '15px',
    borderRadius: '50%',
    backgroundColor: Theme.palette.secondary.main,
    padding: '8px',
    '&:hover': {
      backgroundColor: 'rgba(0, 0, 0, 0.4)',
    },
  },
  filterIcon: {
    width: '15px',
    height: '15px',
    backgroundColor: Theme.palette.secondary.main,
    padding: '8px',
    '&:hover': {
      backgroundColor: 'rgba(0, 0, 0, 0.4)',
    },
  },
  titleText: {
    fontFamily: 'Montserrat',
    fontStyle: 'normal',
    fontWeight: '600',
    fontSize: '18px',
    lineHeight: '22px',
    color: 'black',
  },
  searchText: {
    fontFamily: 'Montserrat',
    fontStyle: 'normal',
    fontWeight: '500',
    fontSize: '14px',
    lineHeight: '0px',
    color: 'black',
  },
  titleSubText: {
    fontFamily: 'Montserrat',
    fontStyle: 'normal',
    fontWeight: '500',
    fontSize: '12px',
    lineHeight: '15px',
    color: 'rgba(0, 0, 0, 0.4)',
  },
  popupLabels: {
    marginTop: '16px',
    fontSize: '12px',
    fontWeight: 600,
    lineHeight: '15px',
    fontStyle: 'normal',
    color: 'rgba(0, 0, 0, 0.4)',
    textTransform: 'uppercase',
    textAlign: 'left',
  },
}));
const ChangeLevelGuide = ({ open, values, close }) => {
  const classes = useStyles();
  const dispatch = useDispatch();

  const [viewChangeLevel, setViewChangeLevel] = useState(open);
  const [selectedLevel, setSelectedLevel] = useState('');
  const [selectedLID, setSelectedLevelID] = useState('');
  const [selectedGuideID, setSelectedGuideID] = useState('');

  const journeyDetails = useSelector((state) => state.JourneyDetails.journeydetails);
  const selectedLevelKey = useSelector((state) => state.getSelectedLevelKey);
  const selectedLevelID = useSelector((state) => state.getSelectedLevelID);

  useEffect(() => {
    journeyDetails.levels.map((value) => (value.id === selectedLevelID ? setSelectedLevel(value.title) : ' '));
  }, []);

  const handleConfigVarChange = (e) => {
    setSelectedGuideID(e.target.name);
    setSelectedLevel(e.target.value);
  };
  const handleClick = (id) => {
    setSelectedLevelID(id);
  };
  const handleClosePopup = () => {
    setViewChangeLevel(false);
    close();
  };
  const submit = async () => {
    dispatch(showProgress(true));
    const data = JSON.stringify(
      values?.type === 'guide'
        ? { levelId: selectedLID }
        : {
            type: 'aiRolePlayExercise',
            levelId: selectedLID,
            id: values?.id,
          },
    );
    const endpoint =
      values?.type === 'guide'
        ? apiEndpoints.JOURNEY_GUIDE_LEVEL.replace('GUIDE_ID', selectedGuideID)
        : apiEndpoints.JOURNEY_AI_EXERCISE_LEVEL_CHANGE;
    await service
      .put(endpoint, data)
      .then(() => {
        dispatch(getLevelDetails('guideDetailsdelete', selectedGuideID));
        dispatch(showProgress(false));
        close();
      })
      .catch((error) => {
        console.log(error);
        dispatch(showProgress(false));
        close();
      });
  };
  const ordinalSuffixOf = (i) => {
    const j = i % 10;
    const k = i % 100;
    if (j === 1 && k !== 11) {
      return `${i}st`;
    }
    if (j === 2 && k !== 12) {
      return `${i}nd`;
    }
    if (j === 3 && k !== 13) {
      return `${i}rd`;
    }
    return `${i}th`;
  };

  return (
    <div>
      <Modal
        onRequestClose={() => false}
        shouldCloseOnEsc={false}
        isOpen={viewChangeLevel}
        style={{
          overlay: {
            backgroundColor: 'hsla(50, 33%, 25%, 0.35)',
          },
          content: {
            padding: '20px 16px 28px',
            width: '375px',
            height: '50%',
            background: '#FFFFFF',
            position: 'absolute',
            left: '50%',
            top: '50%',
            transform: 'translate(-50%, -50%)',
            overflow: 'hidden',
          },
        }}
      >
        <Grid container direction="column">
          <Grid item className={classes.frameStyle}>
            <Grid container direction="row" justifyContent="space-between">
              <Grid item className={classes.titleFrame}>
                <Grid container direction="column">
                  <Grid item className={classes.titleText}>
                    Moving guide
                  </Grid>
                  <Grid item className={classes.titleSubText}>
                    Currently in {ordinalSuffixOf(selectedLevelKey + 1)} Level
                  </Grid>
                </Grid>
              </Grid>
              <Grid item onClick={handleClosePopup}>
                <CloseIcon className={classes.closeIcon} />
              </Grid>
            </Grid>
          </Grid>
          <Grid item style={{ marginTop: '10px', height: '16.5vh' }}>
            <ChangeJourneyCard values={values} />
          </Grid>
          <Grid item>
            <div className={classes.popupLabels}>
              <label htmlFor="guideOverview">Set new Level</label>
            </div>
          </Grid>
          <Grid item style={{ marginTop: '20px' }}>
            <Select
              name={values.id}
              value={selectedLevel}
              onChange={handleConfigVarChange}
              style={{ width: '100%', border: '1px solid black' }}
              disableUnderline
            >
              {journeyDetails.levels.map((value) => (
                <MenuItem
                  style={{ justifyContent: 'left' }}
                  key={value.id}
                  value={value.title}
                  onClick={() => {
                    handleClick(value.id);
                  }}
                >
                  {value.title}
                </MenuItem>
              ))}
            </Select>
          </Grid>
          <Grid item style={{ position: 'absolute', bottom: '4%' }}>
            <Grid container direction="row" justifyContent="center" style={{ marginTop: '4%' }}>
              <Grid item>
                <Button
                  variant="contained"
                  onClick={close}
                  disableElevation
                  style={{
                    width: '111px',
                    height: '42px',
                    fontFamily: 'Montserrat',
                    fontStyle: 'normal',
                    fontWeight: '600',
                    fontSize: '14px',
                    lineHeight: '17px',
                    textAlign: 'center',
                  }}
                >
                  Cancel
                </Button>
              </Grid>

              <Grid item>
                <Button
                  variant="contained"
                  color="primary"
                  style={{
                    width: '216px',
                    height: '42px',
                    marginLeft: '20px',
                    fontFamily: 'Montserrat',
                    fontStyle: 'normal',
                    fontWeight: '600',
                    fontSize: '14px',
                    lineHeight: '17px',
                    textAlign: 'center',
                  }}
                  onClick={submit}
                >
                  Save
                </Button>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </Modal>
    </div>
  );
};
export default ChangeLevelGuide;
